import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import {
  aDeleteTransaction,
  selectDeletePending,
  selectDeleteErrorMessage,
  aCleanupDelete,
} from '../../../../modules/delete-transaction'

import DeleteTransactionDialog from './DeleteTransactionDialog'

export const DIALOG_NAME = 'dialog-delete-transaction'

const mapStateToProps = state => ({
  isDeleting: selectDeletePending(state),
  deleteError: selectDeleteErrorMessage(state),
})

const mapDispatchToProps = {
  deleteTransaction: aDeleteTransaction,
  closeDialog: aCloseDialog,
  cleanUpDelete: aCleanupDelete,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTransactionDialog)
